import {createModel} from '@rematch/core';

import {refreshCaptca} from '~/utils/captcha';
import {ContactUsFormValues} from '~/modals/ContactUsModal/parts/ContactUsForm';
import {CONTACT_US_CAPTCHA_ID} from '~/modals/constants';
import {postContactUs} from '~/services/publicForm';

import type {RootModel} from '../index';

export type ContactUsState = {
  success: boolean;
  error: boolean;
  errorCaptcha: boolean;
};

const defaultState: ContactUsState = {
  success: false,
  error: false,
  errorCaptcha: false,
};

export const contactUs = createModel<RootModel>()({
  state: defaultState,
  reducers: {
    setContactUsSuccess: (state, success: boolean) => ({
      ...state,
      success,
    }),
    setContactUsError: (state, error: boolean) => ({
      ...state,
      error,
    }),
    setContactUsErrorCaptcha: (state, errorCaptcha: boolean) => ({
      ...state,
      errorCaptcha,
    }),
    setContactUsDefaultState: (state, payload: ContactUsState = defaultState) => ({
      ...state,
      ...payload,
    }),
  },
  effects: (dispatch) => {
    return {
      async contactUsSave(data: ContactUsFormValues): Promise<void> {
        dispatch.contactUs.setContactUsDefaultState();

        try {
          const response = await postContactUs(data);

          if (response.status === 204) {
            dispatch.contactUs.setContactUsSuccess(true);
          } else if (response?.data?.error?.message.includes('captcha')) {
            dispatch.contactUs.setContactUsErrorCaptcha(true);
            refreshCaptca(`#${CONTACT_US_CAPTCHA_ID}`);
          } else {
            dispatch.contactUs.setContactUsError(true);
          }
        } catch (error: any) {
          console.error(error);

          if (error?.response?.data?.error?.message.includes('captcha')) {
            dispatch.contactUs.setContactUsErrorCaptcha(true);
          } else {
            dispatch.contactUs.setContactUsError(true);
          }

          refreshCaptca(`#${CONTACT_US_CAPTCHA_ID}`);
        }
      },
    };
  },
});
